export default "__VITE_ASSET__cca269e9__"